import store from '@store'

export default {
  path: ':slug/:id/edit',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "reports-edit" */ './EditReport'),
  beforeEnter(to, from, next) {
    const savedReports = store.state.reports.savedReports
    const report = savedReports.find(r => r.id === Number(to.params.id))
    store.dispatch('reports/viewReport', report)
    next()
  }
}
